/* FOLLIVA INSTRUMENT — cart reservation timer */
(function () {
  "use strict";
  var FL = window.FL || {};
  customElements.define("fl-cart-timer", class extends (FL.Element || HTMLElement) {
    init() {
      var mins = parseInt(this.getAttribute("data-minutes"), 10) || 10;
      var out = this.querySelector("[data-fl-timer]"); if (!out) return;
      var key = "fl_cart_hold";
      var deadline = parseInt(sessionStorage.getItem(key), 10);
      if (!deadline || deadline < Date.now()) { deadline = Date.now() + mins * 60000; sessionStorage.setItem(key, deadline); }
      var self = this;
      function tick() {
        var left = Math.max(0, deadline - Date.now());
        var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
        out.textContent = m + ":" + (s < 10 ? "0" : "") + s;
        if (left <= 0) { if (self._t) clearInterval(self._t); var hold = self.closest(".fc-hold") || self; hold.hidden = true; hold.style.display = "none"; } /* time is up: hide the line, never sit at 0:00 */
      }
      tick(); this._t = setInterval(tick, 1000);
      if (this.track) this.track(() => clearInterval(self._t));
    }
  });
})();

/* ---- Delivery estimate ----
   Wording comes from the block via data-label / data-within / data-countdown;
   without those attributes it stays "Delivery <dates> — order within <time>".
   data-processing / data-transit-min / data-transit-max override FL.settings for one block. */
(function () {
  "use strict";
  var FL = window.FL || {};
  function fmt(d){ try { return d.toLocaleDateString(undefined,{weekday:"short",month:"short",day:"numeric"}); } catch(e){ return (d.getMonth()+1)+"/"+d.getDate(); } }
  function esc(t){ return String(t).replace(/[&<>"']/g, function(c){ return "&#"+c.charCodeAt(0)+";"; }); }
  function addDays(d,n,skipWknd){ var r=new Date(d),a=0; while(a<n){ r.setDate(r.getDate()+1); var g=r.getDay(); if(!skipWknd||(g!==0&&g!==6)) a++; } return r; }
  customElements.define("fl-delivery-estimate", class extends (FL.Element || HTMLElement) {
    init(){
      var out=this.querySelector("[data-fl-delivery-text]"); if(!out) return;
      var s=FL.settings||{}, now=new Date();
      var cutoff=s.cutoffHour!=null?s.cutoffHour:14, proc=(s.processingDays!=null?s.processingDays:1), tmin=s.transitMin!=null?s.transitMin:3, tmax=s.transitMax!=null?s.transitMax:5;
      var ap=parseInt(this.getAttribute("data-processing"),10), an=parseInt(this.getAttribute("data-transit-min"),10), ax=parseInt(this.getAttribute("data-transit-max"),10);
      if(!isNaN(ap)) proc=ap; if(!isNaN(an)) tmin=an; if(!isNaN(ax)) tmax=ax; if(tmax<tmin) tmax=tmin;
      var after=now.getHours()>=cutoff;
      var dispatch=addDays(now, proc+(after?1:0), true);
      var range=fmt(addDays(dispatch,tmin,true))+" – "+fmt(addDays(dispatch,tmax,true));
      var label=this.getAttribute("data-label"), within=this.getAttribute("data-within");
      if(label==null) label="Delivery"; if(within==null) within="order within";
      var msg=(label?esc(label)+" ":"")+"<b>"+range+"</b>";
      if(!after&&this.getAttribute("data-countdown")!=="false"){ var mins=(cutoff-now.getHours()-1)*60+(60-now.getMinutes()); if(mins>0&&mins<1440){ var h=Math.floor(mins/60),m=mins%60; msg+=" — "+(within?esc(within)+" ":"")+h+"h "+(m<10?"0":"")+m+"m"; } }
      out.innerHTML=msg;
    }
  });
})();

/* ---- Countdown ----
   Deadline and repeat period arrive from Liquid as unix seconds, resolved in the store's
   timezone, so every visitor counts down to the same instant instead of to their own clock.
   A repeating timer never ends: it rolls the deadline forward a whole period at a time. */
(function () {
  "use strict";
  var FL = window.FL || {};
  function pad(n) { return n < 10 ? "0" + n : "" + n; }

  /* the buy box may already have defined its own fl-countdown inline; defining twice throws */
  if (customElements.get("fl-countdown")) return;
  customElements.define("fl-countdown", class extends (FL.Element || HTMLElement) {
    init() {
      var out = this.querySelector("[data-fl-cd]"); if (!out) return;
      var deadline = parseInt(this.getAttribute("data-deadline"), 10);
      if (!deadline) return;
      var period = parseInt(this.getAttribute("data-period"), 10) || 0;
      var showDays = this.getAttribute("data-days") !== "false";
      var labels = this.getAttribute("data-labels") !== "false";
      var onEnd = this.getAttribute("data-end") || "hide";
      var self = this;

      function render(left) {
        var d = Math.floor(left / 86400),
            h = Math.floor((left % 86400) / 3600),
            m = Math.floor((left % 3600) / 60),
            s = left % 60,
            seg = [];
        if (!showDays) { h += d * 24; d = 0; }
        if (d > 0) seg.push(labels ? d + "d" : String(d));
        seg.push(labels ? pad(h) + "h" : pad(h));
        seg.push(labels ? pad(m) + "m" : pad(m));
        seg.push(labels ? pad(s) + "s" : pad(s));
        out.textContent = seg.join(labels ? " " : ":");
      }

      function finish() {
        clearInterval(self._t);
        var done = self.querySelector("[data-fl-cd-done]");
        if (onEnd === "text" && done) { out.hidden = true; done.hidden = false; return; }
        /* Removing the message in the theme editor would take it out of reach of the
           merchant editing it, so there it only dims. */
        if (window.Shopify && window.Shopify.designMode) { self.classList.add("is-cd-expired"); return; }
        var msg = self.closest(".fl-announce__msg");
        (msg || self).hidden = true;
        /* An announcement bar whose only message just expired is an empty strip of colour. */
        var bar = self.closest("fl-announce");
        if (bar && !bar.querySelector(".fl-announce__msg:not([hidden])")) {
          var sec = bar.closest('[id^="shopify-section"]');
          if (sec) sec.hidden = true;
        }
        document.dispatchEvent(new CustomEvent("fl:countdown:ended", { detail: { el: self }, bubbles: true }));
      }

      function tick() {
        var now = Math.floor(Date.now() / 1000);
        if (period > 0) { while (deadline <= now) deadline += period; }
        var left = deadline - now;
        if (left <= 0) { finish(); return; }
        render(left);
      }

      tick();
      this._t = setInterval(tick, 1000);
      if (this.track) this.track(function () { clearInterval(self._t); });
    }
  });
})();
